
<template>
  <section>
    <div class="container">
      <table :class="getTableStatus()">
        <thead>
          <tr>
            <th colspan="2">Resumen de la transacción</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Empresa</td>
            <td>{{ company }}</td>
          </tr>
          <tr>
            <td>Identificación</td>
            <td>{{ identification }}</td>
          </tr>
          <tr>
            <td>Fecha</td>
            <td>{{ date }}</td>
          </tr>
          <tr>
            <td>Estado</td>
            <td>{{ status }}</td>
          </tr>
          <tr>
            <td>Código de referencia</td>
            <td>{{ referenceCode }}</td>
          </tr>
          <tr>
            <td>Código de transacción</td>
            <td>{{ transactionCode }}</td>
          </tr>
          <tr>
            <td>Código de confirmación</td>
            <td>{{ confirmationCode }}</td>
          </tr>
          <tr>
            <td>Banco</td>
            <td>{{ bank }}</td>
          </tr>
          <tr>
            <td>Valor</td>
            <td>{{ value }}</td>
          </tr>
          <tr>
            <td>Moneda</td>
            <td>{{ currency }}</td>
          </tr>
          <tr>
            <td>Descripción</td>
            <td>{{ description }}</td>
          </tr>
          <tr>
            <td>Ip</td>
            <td>{{ ip }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
import { getUrlParameters } from "@/global/utils.js";
import { ROUTES } from "@/global/api_routes";
export default {
  data() {
    return {
      company: "",
      identification: "",
      date: "",
      status: "",
      statusCode: "",
      referenceCode: "",
      transactionCode: "",
      confirmationCode: "",
      bank: "",
      value: "",
      currency: "",
      description: "",
      ip: "",
    };
  },
  methods: {
    getTableStatus() {
      let className = 'table-confirmation';
      if (!this.statusCode) {
        return className;
      }
      let validation = this.statusCode == "APPROVED";
      return `${className} ${validation ? "success" : "error"}`;
    },
  },
  mounted() {
    let params = getUrlParameters();
    this.$http
      .post(ROUTES.GLOBAL.PAYU_CONFIRMATION, params)
      .then(({ data }) => {
        if (data.code <= 0) {
          return;
        }
        this.company = data.info.company.name;
        this.identification = data.info.company.identification;
        this.referenceCode = params.referenceCode;
        this.transactionCode = params.transactionId;
        this.confirmationCode = params.cus;
        this.bank = params.pseBank;
        this.value = params.TX_VALUE;
        this.currency = params.currency;
        this.description = params.description;
        this.ip = params.pseReference1;
        this.date = params.processingDate;
        this.status = params.message;
        this.statusCode = params.lapTransactionState;
      });
  },
};
</script> 

<style>
.table-confirmation {
  border: 1px black solid;
  margin: 0 auto;
  width: 90%;
}

.table-confirmation tr td:nth-child(1) {
  width: 40%;
}
.table-confirmation tr th {
  text-align: center;
  background-color: #cccccc;
  color: white;
  font-weight: bold;
  font-size: 2em;
}
.table-confirmation tr td,
.table-confirmation tr th {
  padding: 10px;
  border: 2px #cccccc solid;
}

.table-confirmation.success tr td,
.table-confirmation.success tr th {
  border-color: #40c5b1;
}

.table-confirmation.success tr th {
  background-color: #40c5b1;
}

.table-confirmation.error tr td,
.table-confirmation.error tr th {
  border-color: red;
}

.table-confirmation.error tr th {
  background-color: red;
}

@media (max-width: 850px) {
  .table-confirmation {
    width: 100%;
  }
  .table-confirmation tr th {
    font-size: 1.2em;
  }
  .table-confirmation tr td,
  .table-confirmation tr th {
    padding: 5px;
  }
}
</style>